import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useFavorites } from "@/hooks/useFavorites";
import { BusinessCard } from "@/components/BusinessCard";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const { user, loading } = useAuth();
  const { favs, toggleFav, refresh } = useFavorites();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user) api.get("/favorites").then((r) => setItems(r.data));
  }, [user, favs.length]);

  const handleToggle = async (id) => { await toggleFav(id); refresh(); setItems((p) => p.filter((b) => b.id !== id)); };

  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 min-h-[70vh]">
      <h1 className="font-display text-4xl font-semibold tracking-tight">Your Saved Places</h1>
      <p className="text-slate-500 mt-1 mb-8">Businesses you've favorited across Calgary.</p>
      {items.length === 0 ? (
        <div className="text-center py-20" data-testid="empty-favorites">
          <Heart className="w-12 h-12 text-slate-300 mx-auto mb-4" />
          <p className="font-display text-2xl text-slate-700">No favorites yet</p>
          <p className="text-slate-500 mt-2 mb-6">Start exploring and save the places you love.</p>
          <Button onClick={() => navigate("/explore")} className="rounded-full bg-orange-500 hover:bg-orange-600">Explore now</Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((b, i) => <BusinessCard key={b.id} biz={b} index={i} favorited={true} onToggleFav={handleToggle} />)}
        </div>
      )}
    </div>
  );
}
